let connected = false;

// Provider secrets must never be embedded in a REACT_APP_* browser variable.
// This optional feature remains fail-closed until an authenticated backend proxy is deployed.
export async function connectOpenAI() {
  connected = false;
  return { ok: false, message: 'AI service is unavailable until the secure backend proxy is configured.' };
}

export function isConnected() {
  return connected;
}

export async function askTutor() {
  return {
    id: Date.now(),
    text: 'AI tutor is temporarily unavailable.',
    timestamp: new Date().toISOString()
  };
}
